var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comment-input" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.trim",
          value: _vm.contentLocal,
          expression: "contentLocal",
          modifiers: { trim: true }
        }
      ],
      ref: "input",
      attrs: { type: "text", placeholder: _vm.placeholder },
      domProps: { value: _vm.contentLocal },
      on: {
        keyup: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.handleSubmit($event)
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.contentLocal = $event.target.value.trim()
        },
        blur: function($event) {
          _vm.$forceUpdate()
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "comment-actions" }, [
      _c(
        "button",
        {
          attrs: { disabled: !_vm.contentLocal },
          on: { click: _vm.handleSubmit }
        },
        [_vm._v(_vm._s(_vm.submitText))]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          on: {
            click: function($event) {
              _vm.$emit("cancel")
            }
          }
        },
        [_vm._v("キャンセル")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f4eb382", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f4eb382","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/components/CommentInput.vue
// module id = null
// module chunks = 